import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLocales } from "expo-localization";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import translationEn from "./locales/en.json";

const resources = {
    "en-US": { translation: translationEn },
};

// Get device locale - handles both web and native
const getDeviceLocale = () => {
    try {
        if (Platform.OS === 'web') {
            // Use browser's language on web
            return typeof navigator !== 'undefined' ? navigator.language : 'en-US';
        }
        // Use expo-localization for native
        const locales = getLocales();
        return locales?.[0]?.languageTag ?? 'en-US';
    } catch {
        return 'en-US';
    }
};

const initI18n = async () => {
    let savedLanguage: string | null = null;
    
    try {
        savedLanguage = await AsyncStorage.getItem("language");
    } catch (error) {
        console.warn('[i18n] Could not read saved language:', error);
    }

    if (!savedLanguage) {
        savedLanguage = getDeviceLocale();
    }

    i18n.use(initReactI18next).init({
        compatibilityJSON: "v3",
        resources,
        lng: savedLanguage,
        fallbackLng: "en-US",
        interpolation: {
            escapeValue: false,
        },
    });
};

initI18n();

export default i18n;